import React from "react";

import { BrandTileProps } from "./__internal__/BrandTileProps";
import { ImpressionProviderProps } from "./__internal__/ImpressionProviderProps";
import { BrandTileImpressionTrackingWrapper } from "./BrandTileImpressionTrackingWrapper";
import { LeanBrandTileRenderer } from "./LeanBrandTileRenderer";
import { LeanBrandTileRendererForCarousel } from "./LeanBrandTileRendererForCarousel";
import { LeanBrandTileRendererForMarketList } from "./LeanBrandTileRendererForMarketList";

type BrandTileType = "common" | "carousel" | "marketList";

interface IProps extends BrandTileProps {
  type: BrandTileType;
  impressionProviderProps?: ImpressionProviderProps;
}

export const BrandTile: React.FC<IProps> = ({
  impressionProviderProps,
  type,
  ...rest
}) => {
  if (!impressionProviderProps) {
    return <BrandTileByType tileProps={rest} type={type} />;
  }

  return (
    <BrandTileImpressionTrackingWrapper {...impressionProviderProps}>
      <BrandTileByType tileProps={rest} type={type} />
    </BrandTileImpressionTrackingWrapper>
  );
};

const BrandTileByType: React.FC<{
  type: BrandTileType;
  tileProps: BrandTileProps;
}> = ({ type, tileProps }) => {
  switch (type) {
    case "carousel":
      return <LeanBrandTileRendererForCarousel {...tileProps} />;
    case "marketList":
      return <LeanBrandTileRendererForMarketList {...tileProps} />;
    case "common":
    default:
      return <LeanBrandTileRenderer {...tileProps} />;
  }
};
